// Exchange net-exposure math — mirrors backend server.py exactly so the UI can
// preview locked / freed funds before a bet is placed (no double-locking).

export function betPnl(bet, outcome) {
  const risk = Number(bet.risk != null ? bet.risk : bet.stake) || 0;
  const profit = Number(
    bet.profit != null ? bet.profit : (Number(bet.stake) || 0) * ((Number(bet.odds) || 1) - 1)
  ) || 0;
  const isLay = bet.side === "lay";
  const selWon = (bet.selectionLabel || bet.selection) === outcome;
  const won = isLay ? !selWon : selWon;
  return won ? profit : -risk;
}

export function netPnlByOutcome(bets, outcomes) {
  const map = {};
  for (const o of outcomes) map[o] = bets.reduce((s, b) => s + betPnl(b, o), 0);
  return map;
}

export function exposure(bets, outcomes) {
  if (!bets.length || !outcomes.length) return 0;
  const vals = Object.values(netPnlByOutcome(bets, outcomes));
  return Math.max(0, -Math.min(...vals));
}

export function exposureDelta(existing, newBet, outcomes) {
  if (!outcomes || !outcomes.length) {
    const r = Number(newBet.risk) || 0;
    return { before: 0, after: r, delta: r };
  }
  const before = exposure(existing, outcomes);
  const after = exposure([...existing, newBet], outcomes);
  return { before, after, delta: Math.round((after - before) * 100) / 100 };
}
